import { EMPTY_PLACEHOLDER } from '@patsnap/synapse_common_config'
import { IBaseDrugRna } from '@patsnap/synapse_common_interface'
import { useLocale } from '@pharmsnap/shared/src/composition'
import { defineComponent, PropType } from '@vue/composition-api'
import { getDrugRnaRenderContentList } from './config'

export const BDrugRnaFieldDesc = defineComponent({
  name: 'BDrugRnaFieldDesc',
  props: {
    data: {
      type: Object as PropType<IBaseDrugRna>,
      required: true,
    },
    popperEnable: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const { locale } = useLocale()

    return {
      locale,
    }
  },
  render() {
    const list = getDrugRnaRenderContentList(this.data, this.$i18n)

    const contentList = list
      .filter((i) => !i.invalid(this.data))
      .map(({ label, content: Com }) => {
        const labelText = label
        return (
          <div class={['leading-5 text-sm text-text-t1']}>
            {labelText}
            <Com data={this.data} locale={this.locale}></Com>
          </div>
        )
      })

    if (contentList.length === 0) return <span>{EMPTY_PLACEHOLDER}</span>

    return (
      <div class={['flex flex-col gap-y-2', this.popperEnable ? 'bg-white-default border border-gray-55 rounded px-4 pt-4 pb-2 w-60' : '']}>
        {contentList}
      </div>
    )
  },
})
